import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    config: {
      logo: 'assets/images/logos/latercera.svg',
      title: 'Chevrolet',
      url: 'https://www.latercera.com/canal/tendencias',
      papeldigital: true,
      baseurl: 'https://especiales.latercera.com/uss',
      description: 'San Sebastián, descubre una gran universidad',
      hashtag: '#granuniversidaduss',
      brandtitle: 'Publirreportaje por Universidad San Sebastián',
      reporttitle: 'Especiales La Tercera',
      jumbo: {
        img: 'content/loop-chevrolet-main-compressed.jpg',
        video: 'content/loop-chevrolet-main-compressed.mp4',
        under: '',
      },
      img: 'content/share.jpg',
      slug: '/',
      gallery: false,
      lab: {
        logo: 'assets/images/logos-white/laboratorio-de-contenidos-de-marca.svg',
        title: 'Laboratorio de Contenidos',
        url: {
          name: "home"
        },
        height: '30'
      },
      brand: {
        logo: 'assets/images/logos-white/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '20'
      },
      sponsor: {
        logo: 'assets/images/logo-san-sebastian-white.svg',
        title: 'Universidad San Sebastián',
        url: {
          name: "home"
        },
        height: '35'
      },
      special: {
        logo: 'assets/images/logo-descubre-white.svg',
        title: 'San Sebastián, descubre una gran universidad',
        url: {
          name: "home"
        },
        height: '40'
      },
      front: {
        logo: 'assets/images/logo-descubre-white.svg',
        title: 'San Sebastián, descubre una gran universidad',
        url: {
          name: "home"
        },
        height: '200'
      },
      site: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '37'
      },
      menu: {
        logo: 'assets/images/logos/latercera.svg',
        title: 'La Tercera',
        url: {
          name: "home"
        },
        height: '13'
      },
      'papeldata': {
        url: 'https://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
        image: 'https://edition.pagesuite-professional.co.uk/get_image.aspx?w=300&pbid=33084897-397a-48cc-b3c0-3ce1ec447137&pnum=01&nocache=0609201815'
      },
      'navigation': [
        {
          url: 'https://www.latercera.com/',
          name: 'Inicio'
        },
        {
          url: 'https://www.latercera.com/la-tercera-pm/',
          name: 'La Tercera PM'
        },
        {
          url: 'https: //www.latercera.com/canal/pulso/',
          name: 'Pulso'
        },
        {
          url: 'https://www.latercera.com/canal/politica/',
          name: 'Política'
        },
        {
          url: 'https://www.latercera.com/canal/nacional/',
          name: 'Nacional'
        },
        {
          url: 'https://www.latercera.com/canal/mundo/',
          name: 'Mundo'
        },
        {
          url: 'https://www.latercera.com/canal/opinion/',
          name: 'Opinión'
        },
        {
          url: 'https://www.latercera.com/canal/tendencias/',
          name: 'Tendencias'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Cultura'
        },
        {
          url: 'https://www.latercera.com/canal/cultura/',
          name: 'Entretención'
        },
        {
          url: 'https://www.latercera.com/canal/reportajes/',
          name: 'Reportajes'
        },
        {
          url: 'https://www.latercera.com/canal/el-deportivo/',
          name: 'El Deportivo'
        },
        {
          url: 'https://www.latercera.com/canal/la-tercera-tv/',
          name: 'La Tercera TV'
        },
        {
          url: 'http://edition.pagesuite.com/html5/reader/production/default.aspx?pubname=&pubid=33084897-397a-48cc-b3c0-3ce1ec447137',
          name: 'Edición Impresa'
        }
      ],
      'socialnetworks': [
        {
          url: 'https://twitter.com/latercera',
          icon: 'twitter', //TODO, cargar svgs dinámicamente en init
          name: 'Twitter'
        },
        {
          url: 'https://www.facebook.com/laterceracom',
          icon: 'facebook-f', //TODO, cargar svgs dinámicamente en init
          name: 'Facebook'
        },
        {
          url: 'https://flipboard.com/@latercera',
          icon: 'flipboard', //TODO, cargar svgs dinámicamente en init
          name: 'Flipboard'
        },
        {
          url: 'https://www.instagram.com/laterceracom/',
          icon: 'instagram', //TODO, cargar svgs dinámicamente en init
          name: 'Instagram'
        },
        {
          url: 'https://www.youtube.com/user/latercera',
          icon: 'youtube', //TODO, cargar svgs dinámicamente en init
          name: 'Youtube'
        }
      ]
    }
  },
  mutations: {
    SET_LOGO: (state, val) => {
      state.config.logo = val
    },
  },
  actions: {
    setLogo(context, val) {
      context.commit('SET_LOGO', val)
    },
  }
})
